// 登录权限处理
import $axios from './axios'
import {
    bizURL,
    upmsURL,
    courseURL
} from './baseUrl'

const loginData = {
    // 学员
    studentLogin(params) {
        return $axios({
            url: `${bizURL}/enterprise/employeeLogin`,
            method: "post",
            data: params
        });
    },
    // 企业登录
    login(params) {
        return $axios({
            url: `${bizURL}/enterprise/enterpriseLogin`,
            method: "post",
            data: params
        });
    },
    // 注销
    logout(params) {
        return $axios({
            url: `${bizURL}/employee/enterpriseEmployeeLogOut?tokenId=${sessionStorage.getItem('token')}`,
            method: "post",
            data: params
        });
    },
    // 修改密码
    updatePassword(params) {
        return $axios({
            url: `${bizURL}/employee/enterpriseEmployeeModifyPassword?tokenId=${sessionStorage.getItem('token')}`,
            method: "post",
            data: params
        });
    },
    getSpecial(params) { // 获取注册专业
        return $axios({
            url: `${bizURL}/post/getPostList`,
            method: "get",
            params: params
        });
    },
    uploadImg(params) { // 上传图片
        return $axios({
            url: `${bizURL}/employee/uploadImage`,
            method: "post",
            headers: {
                'Content-Type': 'multipart/form-data;boundary=----WebKitFormBoundarya0zQ2ZGXVTGvdEjy'
            },
            data: params
        });
    },
    personRegister(params) { // 个人注册
        return $axios({
            url: `${bizURL}/registration/registerEmployee`,
            method: "post",
            data: params
        });
    },
    forgetPassword(params) { // 忘记密码
        return $axios({
            url: `${bizURL}/employee/forgetPassword`,
            method: "post",
            data: params
        });
    },
    getCode(params) { // 获取手机验证码
        return $axios({
            url: `${bizURL}/registration/getRegisterVerificationCode`,
            method: "post",
            data: params
        });
    },
    companyRegister(params) { // 企业注册
        return $axios({
            url: `${bizURL}/registration/registerEnterprise`,
            method: "post",
            data: params
        });
    },
    getForgetPhone(params) { // 忘记密码(失去焦点) 获取手机号
        return $axios({
            url: `${bizURL}/employee/getPhoneNumByUname`,
            method: "get",
            params: params
        });
    },
    getForgetCode(params) { // 忘记密码 获取手机验证码
        return $axios({
            url: `${bizURL}/employee/getForgetVerificationCode`,
            method: "get",
            params: params
        });
    },
    getEnter(params) { // 选择机构
        return $axios({
            url: `${upmsURL}/enterprise/getEnterpriseListHome`,
            method: "get",
            params: params
        });
    },
    selectAnnualType() { // 继续教育年度列表---登录使用
        return $axios({
            url: `${courseURL}/trainingRecord/selectAnnualType`,
            method: "get"
        });
    },
}

export default loginData;